import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { getLinkDetails } from 'src/services/role.service';
import { trackEvent } from 'src/analytics/datatrack';
import { EVENT_SHORTLINK_LOAD_ERROR } from 'src/analytics/trackevents';
import { LoadingScreen } from 'src/components/loading-screen';
import ErrorView from '../error';

const RedirectPublicPage = () => {
  // hooks
  const params = useParams();
  const navigate = useNavigate();

  // states
  const [isLoading, setIsLoading] = useState(true);
  const [isInvalidLink, setIsInvalidLink] = useState(false);

  // effects
  useEffect(() => {
    const caller = async () => {
      try {
        setIsLoading(true);
        const res = await getLinkDetails(params.id);
        if (res.success) {
          const navigateUrl = res.body.redirect_link;
          navigate(navigateUrl);
        } else {
          trackEvent(EVENT_SHORTLINK_LOAD_ERROR, {});
          throw new Error(res.message);
        }
      } catch (error) {
        trackEvent(EVENT_SHORTLINK_LOAD_ERROR, { error: error.message });
        setIsInvalidLink(true);
      } finally {
        setIsLoading(false);
      }
    };

    if (params) caller();
  }, [navigate, params]);

  return (
    <>
      {isLoading && <LoadingScreen />}
      {!isLoading && isInvalidLink && <ErrorView variant="invalid-link" />}
    </>
  );
};

export default RedirectPublicPage;
